var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00817871H513V341.996H0V-0.00817871Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 213.929C210.454 213.929 171.987 181.568 162.55 138.353C161.066 145.123 160.316 152.034 160.312 158.965C160.312 212.088 203.375 255.152 256.5 255.152C309.625 255.152 352.688 212.088 352.688 158.965C352.688 151.885 351.901 144.995 350.45 138.353C341.013 181.568 302.546 213.929 256.5 213.929Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.499 86.824L265.452 114.38H294.426L270.986 131.409L279.94 158.966L256.499 141.934L233.059 158.966L242.014 131.409L218.574 114.38H247.546L256.499 86.824Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00622559)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMr);
export default __webpack_public_path__ + "static/media/MR.e7e39e182b901de46853a1fbe5f06eed.svg";
export { ForwardRef as ReactComponent };